import { liquidSettleEvent } from '@/play/liquid/changes'
import { liquidKind } from '@/play/liquid/kind'

/** Every sand voxel in a Sand world is loose sand: it pours, piles and slides. */
export const SAND_KIND = liquidKind('sand', { defaultColor: 0xead6a6 })

/**
 * Sand moving: one input's poured sand and its slide (a pour, one event per pointer event, a whole
 * press one undo step), or the slide into a hole after a dig (folded into the dig's own step).
 */
export const SAND_SETTLE = liquidSettleEvent('experience.sand.settle', SAND_KIND)

/** Reducer handlers for Sand (`experience.sand.*`). */
export const eventHandlers = SAND_SETTLE.handlers
